// app/frontend/pages/ArtistStars.tsx
import React from 'react';
import { Head } from '@inertiajs/react';
import { Container, Title, Text, Image, Accordion, Box, Stack, List, Divider } from '@mantine/core';
import Layout from '../components/Layout';
import { artistStarData } from '../data/artistStarData';
import { useUser } from '../src/context/UserContext';

type NextPageWithLayout = React.FC & {
  layout?: (page: React.ReactNode) => React.ReactNode;
};

const ArtistStars: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>Artist Stars | Where Can We Dance</title>
        <meta property="og:title" content="Artist Stars | Where Can We Dance" />
        <meta
          property="og:description"
          content="Artist Stars create a direct line of monetary support from your supporters. For followers and supporters, you can give stars to your favorite artists along with an encouraging message to support their work and art in the dance world!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/assets/ARTIST STARS WIDE2.jpg" />
        <meta property="og:url" content={typeof window !== 'undefined' ? window.location.href : ''} />
      </Head>

      <Container size="sm" py="xl">
        {/* Hero Image and Intro */}
        <Stack gap="lg">
          {/* <Image
            src="/assets/website header_artist_star.jpg"
            alt="WCWD Artist Stars"
            className="hero-image"
            radius="md"
          /> */}

          <Title order={1} fw={700} lh={1.2} className="text-white rubik-header">
            Artist Stars
          </Title>

          <Text className="text-white">
            Artist stars are a way for dance artists to add an additional income source by receiving stars—online
            donations in multiples of $5.00 USD.
          </Text>

          <Box>
            <Text fw={700} className="text-white">
              1 star = $5.00
            </Text>
            <Text fw={700} className="text-white">
              5 stars = $25.00
            </Text>
            <Text fw={700} className="text-white">
              10 stars = $50.00
            </Text>
          </Box>

          <Text td="underline" fw={700} c="#EA580C">
            Artist stars create a direct line of monetary support from their supporters.
          </Text>

          <Text className="text-white">
            For followers and supporters, you can give stars to your favorite artists along with an encouraging message
            to <strong>support their work and art in the dance world!</strong>
          </Text>

          <Text className="text-white">
            For artists, you can now create an income stream that enables you to receive stars{' '}
            <strong>from your supporters around the world</strong> to supplement your bookings and private lessons!
          </Text>
        </Stack>

        <Divider my="xl" />

        {/* FAQ Sections */}
        {artistStarData.map((section, sectionIndex) => (
          <Box key={sectionIndex} mb="xl">
            <Title order={2} mt="lg" mb="md" fw={600} className="text-white poppins">
              {section.section}
            </Title>

            <Accordion
              multiple
              defaultValue={[]}
              classNames={{
                control: 'faq-accordion-control',
                content: 'faq-accordion-content',
                item: 'faq-accordion-item',
                chevron: 'faq-accordion-chevron',
              }}
            >
              {section.items.map((item, itemIndex) => (
                <Accordion.Item key={itemIndex} value={`${sectionIndex}-${itemIndex}`}>
                  <Accordion.Control>{item.question}</Accordion.Control>
                  <Accordion.Panel>
                    {typeof item.answer === 'string' ? <Text>{item.answer}</Text> : item.answer}
                  </Accordion.Panel>
                </Accordion.Item>
              ))}
            </Accordion>
          </Box>
        ))}
      </Container>
    </>
  );
};

// Set the layout
ArtistStars.layout = (page: React.ReactNode) => <Layout>{page}</Layout>;

export default ArtistStars;
